<div class="container-table-prices">
    <div class="first-table" *ngFor="let bestPrice of bestPrices">
        <div>
            <p>{{bestPrice.title}}</p>
        </div>
        <table>
            <tbody>
              <tr *ngFor="let bestPriceAux of bestPrice.bestPrices; let indice=index">
                <td class="hide-numbers">{{indice + 1}}</td>
                <td>
                    <app-system-picture
                        [alt]="bestPriceAux.system.attributes.name"
                        title="Saldo {{bestPriceAux.system.attributes.name}}"
                        [systemId]="bestPriceAux.system.id"></app-system-picture>
                        <source _ngcontent-serverapp-c1758639354="" type="image/webp" srcset="https://api.saldo.com.ar/img/sistemas2/palpal.medium.webp 150w,
                https://api.saldo.com.ar/img/sistemas2/palpal.big.webp 400w">
                </td>
                <td class="text-table-prices">{{bestPriceAux.price.toFixed(system.attributes.decimal_places)}} <span>{{system.attributes.currency}}</span></td>
                <td class="best-price-table-buttons">
                    <a mat-stroked-button [routerLink]="bestPriceAux.link">{{bestPrice.action}}</a>
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button routerLink="/comprar-vender/{{bestPriceAux.system.id}}" mat-menu-item>
                          Mas información
                        </button>
                    </mat-menu>
                </td>
              </tr>
            </tbody>
        </table>
    </div>
</div>
